import * as svg from "../../../assets/thunder-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const ThunderIcon = iconBuilder(svg, "ThunderIcon", "0 0 16 17");
